import React from "react";
import { cn } from "@/lib/utils";
import { buttonVariants, buttonSizes, focusStyle, fontWeight } from "@/theme";

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
  size?: "sm" | "md" | "lg";
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "primary", size = "md", ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          `inline-flex items-center justify-center gap-2 rounded-lg ${fontWeight.semibold} transition-all focus:outline-none ${focusStyle.primary} focus:ring-offset-0 disabled:opacity-70 disabled:cursor-not-allowed`,
          buttonVariants[variant],
          buttonSizes[size],
          className
        )}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
